<template>
  <div>
    <input
      class="input-box"
      v-model="internalValue"
      :placeholder=text
      @change="onChangeValue"
       autocomplete="on"
       :list=listId
    />
    <datalist :id=listId>
      <option v-for="n in autocomplete" :key="text+n">{{n}}</option>
    </datalist>
  </div>
</template>

<script>
export default {
  name: 'input-box',
  props: {
    text: { type: String },
    value: {
      type: [String, Number, Boolean],
      default: undefined
    },
    autocomplete: { type: Array }
  },
  computed: {
    internalValue: {
      get () {
        return this.value
      },
      set (newVal) {
        if (this.value !== newVal) this.$emit('input', newVal)
      }
    },
    listId () {
      return this.text + 'list'
    }
  },
  methods: {
    onChangeValue (e) {
      if (e.currentTarget) this.$emit('change-value', e.currentTarget.value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../../unified.scss';
.input-box {
    width:100%;
    padding: $very-little-margin;
    margin: $very-little-margin $no-margin;
    box-sizing: border-box;
    font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Atoms/InputBox.vue